import React, { FC, useState } from 'react';
import Link from 'next/link';
import { useAccount } from 'frontastic';
import Button from 'components/commercetools-ui/atoms/button';
import Spinner from '../spinner';
import { useParams } from 'next/navigation';
import { useRouter } from 'next/navigation';

export interface NavigationMenuProps {
  loggedIn: boolean;
}

const NavigationMenu: FC<NavigationMenuProps> = ({ loggedIn }) => {
  const [loading, setLoading] = useState(false);
  const { logout, account } = useAccount();
  const router = useRouter();
  const { locale } = useParams();

  const menuLinks = [
    {
      title: 'Projects',
      link: `/${locale}/project-builder/`,
      enabled: true,
    },
    {
      title: 'My account',
      link: `/${locale}/my-account`,
      enabled: false,
    },
  ];

  const logOut = async () => {
    setLoading(true);
    await logout();
    setLoading(false);
    router.replace('/');
  };

  return loading ? (
    <Spinner />
  ) : (
    <div>
      <div className={`min-w-[300px] rounded-md bg-[#F7F7F7] text-black`}>
        {loggedIn && (
          <ul>
            {menuLinks.map((e) => (
              <li
                onClick={() => {
                  if (!account?.firstName && e.title === 'My account') router.push(`/company-registration/`);
                  else router.push(`${e.link}`);
                }}
                className="cursor-pointer border-b border-[#DDDDDD] p-8 last:border-none hover:bg-gray-300"
                key={e.title}
              >
                {e.title}
              </li>
            ))}

            <li
              onClick={logOut}
              className="cursor-pointer border-b border-[#DDDDDD] p-8 last:border-none hover:bg-gray-300"
            >
              Log out
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default NavigationMenu;
